import React from 'react';
import { connect } from 'react-redux';

import ConfirmationModal from 'shared/ui/modals/ConfirmationModal';
import { deleteSubsOrder } from 'core/redux/subscriptions/actions';

const deleteConfirmationModal = ({ order, deleteOrder, onCloseModal, selectedAccount, selectedStack }) => {
  return (
    <>
      <ConfirmationModal
        width={500}
        onCloseModal={onCloseModal}
        onSuccess={onCloseModal}
        onFailure={onCloseModal}
        cancelHandler={onCloseModal}
        handleRequestClose={onCloseModal}
        submitHandler={async () => {
          return await deleteOrder({
            env: selectedAccount?.value.toLowerCase(),
            orgId: order.organization_id,
            subId: order.subscription_id,
            tableStackName: selectedStack?.value,
          });
        }}
        bodyText={'Do you really want to delete this order?'}
        title={'Delete Order'}
        svgFileName={'order'}
        iconDimensions={{ height: 20, width: 22 }}
        alt="User"
        confirmText="Delete"
        cancelText="Cancel"
      />
    </>
  );
};

export default connect(
  (state) => ({
    // isFetchingUsers: state.user.isFetchingUsers,
  }),
  (dispatch) => ({
    deleteOrder: (orderDetails) => dispatch(deleteSubsOrder(orderDetails)),
  })
)(deleteConfirmationModal);
